<template>
  <div class="list-table outside">
    <div class="scroll-table" v-if="!isMobile">
      <table class="main-table">
        <thead>
          <th>
            <input type="checkbox" class="checkbox" v-model="checkAll" @change="toggleCheckAll" />
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
            @click="sort('name')">
            {{ $t('provider.availability.businessName') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'name'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'license'}"
            @click="sort('license')">
            {{ $t('provider.availability.type') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'license'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'sector'}"
            @click="sort('sector')">
            {{ $t('provider.availability.homeSector') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'sector'"></i>
          </th>
          <th>Service</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'vehicle'}"
            @click="sort('vehicle')">
            {{ $t('provider.availability.vehicle') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'vehicle'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'startShift'}"
            @click="sort('startShift')">
            {{ $t('provider.availability.availableFrom') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'startShift'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'endShift'}"
            @click="sort('endShift')">
            {{ $t('provider.availability.availableUntil') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'endShift'"></i>
          </th>
          <th>{{ $t('provider.availability.phone') }}</th>
          <th :class="['sortable', {'active':currentOrder.field === 'assigned'}]"
            @click="sort('assigned')">
            Assigned Trips
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'assigned'"></i>
          </th>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td>
              <input type="checkbox" class="checkbox" 
              :value="user.id" v-model="checked" />
            </td>
            <td>
              <a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.name }}</a>
            </td>
            <td><span :class="['type', user.licenseType]">{{ user.licenseType }}</span></td>
            <td class="home-sector">{{ user.homeSector }}</td>
            <td class="pax-dtd">{{ user.paxDtd }}</td>
            <td class="vehicle-type">{{ user.vehicleType }}</td>
            <td class="available-from">{{ user.availableFrom }}</td>
            <td class="available-until">{{ user.availableUntil }}</td>
            <td class="mobile">
              <a @click="call(user)">{{ user.mobile }}</a>
            </td>
            <td>
              <a @click="showTrips(user)" v-if="user.hasAssignment">View</a>
              <!-- <a @click="showTrips(user)" v-if="checkList.length && checkList.find(x=>x.id===user.id).status === 'hasRsvp'">View</a>
              <span v-else-if="checkList.length && checkList.find(x=>x.id===user.id).status === 'loading'">
                <i class="fas fa-spinner fa-spin fa-fw"></i>Loading...
              </span>
              <a @click="showTrips(user)" v-show="false"><br/>DEBUGGER</a> -->
            </td>
          </tr>

          <tr v-show="loading && users.length === 0">
            <td colspan="10" class="table-block">
              <transition name="slide-up">
                <div v-show="loading" class="loader">
                  <i class="fas fa-spinner fa-spin"></i>
                  {{ $t('consumer.list.gettingUsers') }}
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="users.length === 0 && !loading">
            <td colspan="10" class="table-block">
              <transition name="slide-up">
                <div v-show="users.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!~
                </div>
              </transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards" v-else>
      <div v-show="loading && users.length === 0" class="result-stat">
        <transition name="slide-up">
          <div v-show="loading" class="loader">
            <i class="fas fa-spinner fa-spin"></i>
            {{ $t('consumer.list.gettingUsers') }}
          </div>
        </transition>
      </div>

      <div v-show="users.length === 0 && !loading" class="result-stat">
        <transition name="slide-up">
          <div v-show="users.length === 0 && !loading" class="empty-result">
            <i class="far fa-frown-open fa-3x"></i><br/>
            No record found!
          </div>
        </transition>
      </div>
      <div class="card" v-for="(user, index) in users" :key="index">

        <div class="card-header">
            <input type="checkbox" class="checkbox" 
                :value="user.id" v-model="checked" />
              <span :class="['type', user.licenseType]">{{ user.licenseType }}</span>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.businessName') }}: </div>
          <div class="value"><a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.name }}</a></div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.homeSector') }}: </div>
          <div class="value">{{ user.homeSector }}</div>
        </div>

        <div class="title">
          <div class="label">Service: </div>
          <div class="value">{{ user.paxDtd }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.vehicle') }}: </div>
          <div class="value">{{ user.vehicleType }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.availableFrom') }}: </div>
          <div class="value">{{ user.availableFrom }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.availableUntil') }}: </div>
          <div class="value">{{ user.availableUntil }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.phone') }}: </div>
          <div class="value"> <a @click="call(user)">{{ user.mobile }}</a></div>
        </div>

        <div class="title btn">
          <a @click="showTrips(user)" v-if="user.hasAssignment" class="button cta xsmall">View</a>
        </div>
      </div>
    </div>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="users.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':modal.show}">
      <div class="bg-overlay"></div>
      <div class="modal-content">
        <div class="content-box">
          <h1>Assigned Trips</h1>
          <!-- <div class="res-type">
            <div class="active" @click="getRsvp('upcoming')">UPCOMING</div>
            <div @click="getRsvp('completed')">COMPLETED</div>
          </div> -->
          <div class="list-table tables">
            <table class="main-table">
              <thead>
                <th>ID</th>
                <th>Pickup Date</th>
                <th>Pickup</th>
                <th>Dropoff</th>
                <th>Status</th>
              </thead>
              <tbody>
                <tr v-for="(data, index) in modal.trips" :key="index" v-show="!modal.loading && dateCheck(data.pickupDate)">
                  <td>
                    <a :href="`/#/package/${data.id}`" v-if="data.type === 'package'" target="_blank">{{ data.id }}<i class="fa fa-cube"></i></a>
                    <a :href="`/#/reservation/${data.id}`" v-else target="_blank">{{ data.id }}</a>
                  </td>
                  <td><span class="pickup-date">{{ data.pickupDate }}</span></td>
                  <td><span class="location">{{ data.pickup }}</span></td>
                  <td><span class="location">{{ data.dropoff }}</span></td>
                  <td>
                    <span :class="['status', data.status, data.dispatchStatusX]">{{ data.statusLabel }}</span>
                    <!-- <span :class="['status', data.status.toLowerCase()]">{{ data.status }}</span> -->
                  </td>
                </tr>

                <tr v-show="modal.loading">
                  <td colspan="4" class="table-block">
                    <div v-show="modal.loading" class="loader">
                      <i class="fas fa-spinner fa-spin"></i>
                      Getting assigned trips
                    </div>
                  </td>
                </tr>

                <tr v-show="modal.trips.length === 0 && !modal.loading">
                  <td colspan="4" class="table-block">
                    <div v-show="modal.trips.length === 0 && !loading" class="empty-result">
                      <i class="far fa-frown-open fa-3x"></i><br/>
                      No record found!~
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="action">
            <a class="button cta small" @click='modal.show = false'>Close</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ft from '@/modules/api/featureToggle'
import ApiProviderAvailability from '@/modules/api/provider/availability'

export default {
  name: 'driver-table',
  props: ['isMobile'],
  data () {
    return {
      selected: [],
      lastDriver: '',
      modal: {
        tab: 'upcoming',
        trips: [],
        completed: [],
        show: false,
        loading: false,
      },
      checkList: [], // RSVP [upcoming] check list
      checkAll: false,
      tmpData: null
    }
  },
  computed: {
    users () { return this.$store.state.provider.availability.list },
    loading () { return this.$store.state.provider.availability.loading },
    currentOrder () {
      let prov = this.$store.state.provider.availability
      return { field: prov.order, asc: prov.orderAsc }
    },
    perPage: {
      get: function () { return this.$store.state.provider.availability.perPage },
      set: function (value) {
        this.$store.commit('provider/setAvailabilityPerPage', parseInt(value))
        this.$store.commit('provider/setAvailabilityCurrentPage', 1)
        this.getList()
      }
    },
    pageData () {
      let tableData = this.$store.state.provider.availability
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.provider.availability.currentPage },
      set: function (value) {
        this.$store.commit('provider/setAvailabilityCurrentPage', parseInt(value))
        this.getList()
      }
    },
    isLastPage () {
      let prov = this.$store.state.provider.availability
      return (prov.currentPage * prov.perPage) >= prov.maxList
    },
    totalPage () {
      let prov = this.$store.state.provider.availability
      return Math.ceil(prov.maxList / prov.perPage)
    },
    checked: {
      get: function () { return this.$store.state.provider.availability.checked },
      set: function (value) {
        this.$store.commit('provider/setAvailabilityChecked', value)

        let users = []
        this.users.forEach(user => {
          if (users.indexOf(user.id) === -1) {
            users.push(user.id)
          }
        })
        this.checkAll = users.length === value.length
      }
    }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('provider/setAvailabilityIsLoading', true)
      ApiProviderAvailability.getList(self, res => {
        self.$store.commit('provider/setAvailabilityIsLoading', false)
      })
    },
    sort (field) {
      if (this.loading) { return }
      this.checkAll = false
      let prov = this.$store.state.provider.availability
      if (field !== prov.order) {
        this.$store.commit('provider/setAvailabilityOrderAsc', 1)
      } else {
        this.$store.commit('provider/setAvailabilityOrderAsc', prov.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('provider/setAvailabilityOrder', field)
      this.$store.commit('provider/setAvailabilityCurrentPage', 1)
      this.getList()
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('provider/setAvailabilityCurrentPage', this.$store.state.provider.availability.currentPage - 1)
      this.getList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('provider/setAvailabilityCurrentPage', this.$store.state.provider.availability.currentPage + 1)
      this.getList()
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    checkTrips () {
      let self = this
      if (!self.checkList.length) { return }

      let driverIndex = self.checkList.findIndex(x => x.status === 'loading')
      if (driverIndex < 0) { return }
      let id = self.checkList[driverIndex].id

      let prov = self.$store.state.provider
      self.$sdk.get(`/provider/${id}/rsvp/upcoming`, {
        token: self.$store.state.session.sessionToken,
        pageSize: 999,
        pageNum: 1,
        pickupSince: moment(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: moment(prov.availability.until, 'X').format('YYYY-MM-DD')
      }, res => {
        // let index = self.checkList.findIndex(x => x.id === id)
        if (self.checkList[driverIndex]){
          if (res.error) {
            self.checkList[driverIndex].status = 'error'
          } else {
            self.checkList[driverIndex].status = res.list.length ? 'hasRsvp' : 'empty'
          }
        }
        self.checkTrips()
      })
    },
    showTrips (data) {
      let self = this
      if (self.modal.loading) { return }
      self.lastDriver = data
      self.modal = {
        show: true,
        loading: true,
        trips: []
      }

      self.tmpData = data
      let prov = self.$store.state.provider
      self.$sdk.get(`/provider/${data.id}/rsvp/upcoming`, {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        pageNum: 1,
        pickupSince: moment(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: moment(prov.availability.until, 'X').format('YYYY-MM-DD')
      }, res => {
        // self.modal.loading = false
        if (res.error) {
          console.log('ERROR', res.error)
          return
        }

        let threshold = self.$settings.get('OfferLimitThreshold') || 150
        threshold = 1 + (parseFloat(threshold) / 100)

        // let start = moment(prov.availability.since, 'X')
        // let end = moment(prov.availability.until, 'X')
        res.list.forEach(r => {
          if (r.type === 'package') {
            // let withInRange = false
            // r.data.rsvp.every(x => {
            //   let btt = Math.floor(x.etaInSec * threshold)
            //   if (moment(x.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').isBetween(start, end) ||
            //     moment(x.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').add(btt, 'seconds').isBetween(start, end)
            //   ) {
            //     withInRange = true
            //     return false
            //   }
            //   return true
            // })

            // if (withInRange) {
              self.modal.trips.push(self.formatPkg(r.data))
            // }
          } else {
            // let btt = Math.floor(r.data.etaInSec * threshold)
            // if (moment(r.data.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').isBetween(start, end) ||
            //   moment(r.data.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').add(btt, 'seconds').isBetween(start, end)
            // ) {
              self.modal.trips.push(self.formatRsvp(r.data))
            // }
          }
        })
        setTimeout(() => {
          self.getCompletedTrips(data)
        }, 1000)
      })
    },
    formatRsvp (data) {
      let pickupDate = moment(data.pickupDate, 'YYYY-MM-DD HH:mm')

      let status = this.buildStatus(data)
      return {
        id: data.ID,
        type: 'rsvp',
        pickupDate: pickupDate.format('MM/DD/YYYY ' + ft.timeFormat(this, false)),
        dateSort: parseInt(pickupDate.format('X')),
        pickup: data.pickupLocation.title,
        dropoff: data.dropoffLocation.title,
        status: status.class,
        statusLabel: status.label,
        dispatchStatusX: status.dispatchStatusX
      }
    },
    formatPkg (data) {
      let lastStop = data.rsvp.find(x => x.ID === data.stops[data.stops.length - 1].reservationID)
      let pickupDate = moment(data.package.pickupTime, 'YYYY-MM-DD@HH:mm')

      let status = this.buildStatus(data)
      return {
        id: data.package.id,
        type: 'package',
        pickupDate: pickupDate.format('MM/DD/YYYY ' + ft.timeFormat(this, false)),
        dateSort: parseInt(pickupDate.format('X')),
        pickup: data.package.firstPickup,
        dropoff: lastStop.dropoffLocation.title,
        status: status.class,
        statusLabel: status.label,
        dispatchStatusX: status.dispatchStatusX
      }
    },
    buildStatus (data) {
      let status = {
        class: data.status,
        label: data.status
      }
      if (status.label === 'ready' || data.dispatchStatus === 'ready') {
        status.class = 'ready'
        status.label = 'Ready to go'
      }
      if (status.label === 'onboard') status.label = 'On Board'
      if (data.dispatchStatus === 'dispatched') {
        status.class = data.dispatchStatus
        status.label = data.dispatchStatus
      }
      if (data.dispatchStatus === 'requires_dispatch') {
        status.class = 'requires-dispatch'
        status.label = 'Requires Dispatch'
      }
      if (data.dispatchStatus === 'autodispatch') {
        status.class = 'auto-dispatch'
        status.label = 'Auto Dispatch'
      }
      let dispatchStatusX = ''
      if (status.class === 'dispatched') {
        let pickupTime = moment(data.pickupDate, 'YYYY-MM-DD hh:mm:ss')
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        let currentTime = parseInt(moment().format('X'))
        if (['ontheway', 'arrived'].indexOf(data.status) > -1) dispatchStatusX = 'on-time'
        else if (pickupTime1 <= currentTime) dispatchStatusX = 'very-late'
        else if (pickupTime115 <= currentTime) dispatchStatusX = 'late'
        else if (data.status === 'upcoming') dispatchStatusX = 'accepted'
      }
      return {
        class: status.class,
        label: status.label,
        dispatchStatusX: dispatchStatusX
      }
    },
    toggleCheckAll () {
      if (this.users.length) {
        let users = []
        if (this.checkAll) {
          this.users.forEach(user => {
            if (users.indexOf(user.id) === -1) {
              users.push(user.id)
            }
          })
        }
        this.$store.commit('provider/setAvailabilityChecked', users)
      }
    },
    getRsvp (x) {
      this.modal.tab = x
      this.showTrips(this.lastDriver, x)
    },
    getCompletedTrips (data) {
      let self = this

      let prov = self.$store.state.provider
      self.$sdk.get(`/provider/${data.id}/rsvp/history`, {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        pageNum: 1,
        pickupSince: moment(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: moment(prov.availability.until, 'X').add(1, 'days').format('YYYY-MM-DD')
      }, res => {
        if (res.error) {
          self.modal.loading = false
          console.log('ERROR', res.error)
          return
        }
        res.list.forEach(r => {
          if (r.type === 'package') {
            self.modal.trips.push(self.formatPkg(r.data))
          } else {
            self.modal.trips.push(self.formatRsvp(r.data))
          }
        })
        setTimeout(() => {
          self.modal.trips.sort((b, a) => b.dateSort - a.dateSort)
          self.modal.loading = false
        }, 200)
      })
    },
    dateCheck (date) {
      let from = moment(this.tmpData.availableFrom, 'MM/DD/YYYY hh:mmA')
      date = moment(date, 'MM/DD/YYYY hh:mmA')
      return from.isSameOrBefore(date)
    }
  },
  watch: {
    users (val) {
      this.checkAll = false
      this.checkList = []
      val.forEach(driver => {
        this.checkList.push({
          id: driver.id,
          status: 'loading'
        })
      })
      // this.checkTrips()
    },
    // checkAll (val) {
      
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
.status{
  &.ready{ background: #6dabc3; }
  &.accepted{ background: #777; }
  &.on-time{ background: #26d97a; }
  &.late{ background: #dc9831; }
  &.ontheway{ background: #f38d56; }
  &.very-late{ background: #e62e2e; }
  &.open-credit{ background: #29c3c3; }
}

.list-table.outside{
  border: 1px solid #aaa;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.sticky{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 44px;
  z-index: 3;

  tbody{ visibility: hidden; }
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .city, .phone{}
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}

.checkbox{
  margin-top: 5px;
  cursor: pointer;
}

.fix-footer{
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    vertical-align: middle;
    display: none;
    position: relative;
    z-index: 2;

    .list-table{
      padding: 0 25px;
      position: relative;
      overflow: auto;
      max-height: calc(80vh - 115px);
    }
    .content-box{
      width: 800px;
      padding: 25px 0 90px;
      max-height: 80vh;
      min-height: 300px;
      overflow: hidden;
      margin: 0 auto;
      background: #fff;
      text-align: center;
      border-radius: 6px;
      box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
      position: relative;

      h1{
        margin: 0 0 10px;
        line-height: 1;
        font-size: 32px;
        color: #434343;
      }
      .main-table{
        border: 1px solid #aaa;
        margin-bottom: 20px;
      }
      a { text-decoration: none; }
      .fa-cube{ margin-left: 3px; }
      .pickup-date{ color: #888; }
      .action {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        padding: 5px;
        background: #fafafa;
        border-top:1px solid #f3f3f3;

        .button { width: 150px; }
      }
    }
  }
  &.show{
    display: table;

    .modal-content{
      display: table-cell;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
  .close{
    display: block;
    margin-top: 5px;
    font-size: 14px;
    color: #999;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
      color: #555;
    }
  }
}
.res-type{
  display: flex;
  gap: 20px;
  margin-bottom: 10px;

  div{
    color: #bbb;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    &.active{
      color: #2071db;
      border-bottom-color: #2071db;
    }
  }
}

.status{
  text-transform: uppercase;
  letter-spacing: .4px;
  background: #666;
}

@media only screen and (max-width: 430px) {
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      padding: 15px 0px;
      margin-right: 15%;

      select {
        width: 55px;
      }
    }
  }

  .loader, .empty-result {
    text-align: center;
    padding: 50px 0;
  }

  .cards {
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;
    .result-stat {
      width: 100%;
    }
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        input {
          margin-top: 5px;
          cursor: pointer;
          width: auto;
          margin-right: 5px;
        }

          .type{
            display: inline-block;
            padding: 3px 6px;
            text-transform: uppercase;
            border-radius: 4px;
            color: #fff;
            font-size: 11px;
            font-weight: 600;

            &.tnc{ background: #2ab77c; }
            &.tcp{ background: #3f81a0; }
            &.psc{ background: #de6c2a; }
          }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        input {
          margin-right: 5px;
        }

        &.btn {
          text-align: center;
          justify-content: center;
          margin-top: 15px;
          margin-bottom: 10px;

          .button {
            padding: 10px 20px;
          }
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }

  .modal .modal-content .content-box {
    width: auto;
    padding: 25px 25px 70px;

    h1 {
      font-size: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderAvailability/DriverTable.vue